import axios from "axios";
import { toast } from "react-toastify";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const urlQuery = (queryParams) => {
  const query = Object.entries(queryParams).reduce((query, param) => {
    return `${query}${encodeURIComponent(param[0])}=${encodeURIComponent(
      param[1]
    )}&`;
  }, "");
  return query.slice(0, -1);
};

const instance = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export default instance;

const getInstance = ({ headers: _headers = {}, baseUrl }) => {
  const Instance = axios.create({
    baseURL: baseUrl || BASE_URL,
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("access_token"),
      ..._headers,
    },
  });

  Instance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      // handle the error
      toast.dismiss();
      toast.error(error?.response?.data?.error?.message);
      return Promise.reject(error?.response);
    }
  );
  return Instance;
};

export const Client = {
  get: (endpoint, config = {}) => {
    const Instance = getInstance({
      headers: config.headers || {},
      baseUrl: config.baseUrl,
    });
    const queryParams = urlQuery(config.params || {});
    return Instance(`${endpoint}${queryParams ? `?${queryParams}` : ""}`);
  },
  post: (endpoint, data, config = {}) => {
    const Instance = getInstance({ headers: config.headers || {} });
    return Instance.post(endpoint, data, {
      params: config.params || {},
    });
  },
  delete: (endpoint, data, config = {}) => {
    const Instance = getInstance({ headers: config.headers || {} });
    return Instance.delete(endpoint, data);
  },
  put: (endpoint, data, config = {}) => {
    const Instance = getInstance({ headers: config.headers || {} });
    return Instance.put(endpoint, data);
  },
  patch: (endpoint, data, config = {}) => {
    const Instance = getInstance({ headers: config.headers || {} });
    return Instance.patch(endpoint, data);
  },
};
